import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';

import './index.scss';
import store from './store/CreateStore';
import Config from './utils/Configuration';
import {pagePath, router} from './RouteConfig';
import {RouterProvider} from 'react-router-dom';
import {Loader} from './global';
import FloatyWhatsApp from './global/FloatyWhatsApp';

const setGoogleMapsAPIScript = () => {
    const scriptEl = document.createElement('script');
    window.initMap = () => {}; // I am just testing this feature because callback is now mandatory
    scriptEl.defer = true;
    scriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${Config.apiConfig.gMapsKey}&libraries=places&callback=initMap`;
    document.head.append(scriptEl);
};

const setCanonicalTag = () => {
    const linkEl = document.createElement('link');
    linkEl.rel = 'canonical';
    linkEl.href = window.location.origin + '/';
    document.head.append(linkEl);
};

const disableBfCacheForAuthPages = () => {
    const onPageShow = (event) => {
        if (event.persisted && window.location.pathname.startsWith(pagePath.auth)) {
            window.location.reload();
        }
    };

    window.addEventListener('pageshow', onPageShow);
};

const preventDiscoveringStaging = () => {
    if (!Config.isProdEnv) {
        const robotMeta = document.createElement('meta');
        robotMeta.name = 'robots';
        robotMeta.content = 'noindex,nofollow';
        document.head.prepend(robotMeta);
    }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <div className='d-flex flex-column min-vh-100'>
            <RouterProvider router={router} />
        </div>
        <Loader />
        <FloatyWhatsApp />
    </Provider>
);

setCanonicalTag();
setGoogleMapsAPIScript();
disableBfCacheForAuthPages();
preventDiscoveringStaging();
